module.exports = __webpack_public_path__ + "f3ff5a49c10043793946d0f03f9d64f5.png";